import { UpdateMerchantServiceCommand } from "@/models/club";
import { useMutation } from "@tanstack/react-query";
import { appointmentService } from "..";

function useUpdateMerchantService() {
  return useMutation({
    mutationFn: (command: UpdateMerchantServiceCommand) => {
      return appointmentService.updateMerchantServices(command);
    },
  });
}

export default useUpdateMerchantService;
